import { get, post, put, remove } from '../api';
import EventEmmiter from '../../../providers/event.emmiter';

// Aba Publicações (F147): análises do Pulso que o cliente acha na tela de solicitações.
export const publicationEvents = new EventEmmiter();
export const UNREAD_CHANGED = 'unreadChanged';

const emptyGroups = { action: 0, progress: 0, history: 0 };

// group: 'active' (precisa de você + com a Facilita) ou 'history'; sem grupo, tudo (a busca usa assim).
// asOf: hora em que a tela abriu a lista; as páginas seguintes mantêm a ordem dela.
const list = ({ search = '', group, page = 1, perPage = 20, asOf } = {}) =>
    get({ type: 'user', service: 'customer-publications', queryString: { search: search || undefined, group: group || undefined, page, perPage, asOf: asOf || undefined } })
        .then(res => res.data || { items: [], total: 0, unread: 0, groups: emptyGroups, group: group || null, page, perPage });

const summary = () =>
    get({ type: 'user', service: 'customer-publications/summary' })
        .then(res => res.data || { total: 0, unread: 0, groups: emptyGroups });

// Minha conta › Certificado e tribunais: as OABs que o Pulso acompanha e quantas publicações já chegaram.
const monitoring = () =>
    get({ type: 'user', service: 'customer-publications/monitoring' })
        .then(res => res.data || { oabs: [], publications: 0 });

// Pulso na loja e em Minha conta: se o pacote comporta, preços pelo saldo, termo, aceite, OABs e consumo do mês.
const pulso = () =>
    get({ type: 'user', service: 'customer-publications/pulso' }).then(res => res.data);

const pulsoTerm = () =>
    get({ type: 'user', service: 'customer-publications/pulso/term' }).then(res => res.data);

const acceptPulsoTerm = () =>
    post({ type: 'user', service: 'customer-publications/pulso/term' }).then(res => res.data);

// revokeCredentials: no mesmo fluxo, o titular revoga a guarda do próprio certificado (Termo do Pulso 15.2.1 e 15.3).
const revokePulsoTerm = ({ revokeCredentials = false } = {}) =>
    remove({ type: 'user', service: `customer-publications/pulso/term${revokeCredentials ? '?revokeCredentials=true' : ''}` })
        .then(res => res.data);

const findById = (id) =>
    get({ type: 'user', service: `customer-publications/${id}` }).then(res => res.data);

const markViewed = (id) =>
    put({ type: 'user', service: `customer-publications/${id}/read` }).then(res => res.data);

// Escolha do caminho (F224): alternative = número da opção (0 = nenhuma peça). Volta a publicação atualizada.
const choose = (id, alternative) =>
    post({ type: 'user', service: `customer-publications/${id}/choice`, data: { alternative } }).then(res => res.data);

const markShownViewed = (ids) =>
    put({ type: 'user', service: 'customer-publications/read', data: { ids } }).then(res => res.data);

const markAllViewed = () =>
    put({ type: 'user', service: 'customer-publications/read-all' }).then(res => res.data);

// Badge do menu e da aba leem a mesma contagem; quem marca lida avisa os dois.
const notifyUnread = (unread) => publicationEvents.emmit(UNREAD_CHANGED, unread);

const updateAutomaticRequests = (enabled) =>
    put({ type: 'user', service: 'customer-publications/pulso/automatic-requests', data: { enabled } }).then(res => res.data);

// F388: até 2 números de WhatsApp para o relatório do Pulso; lista vazia volta ao telefone do cadastro.
const updateReportPhones = (additional) =>
    put({ type: 'user', service: 'customer-publications/pulso/report-phones', data: { additional } }).then(res => res.data);

export default { updateAutomaticRequests, updateReportPhones, list, summary, monitoring, pulso, pulsoTerm, acceptPulsoTerm, revokePulsoTerm, findById, markViewed, choose, markShownViewed, markAllViewed, notifyUnread };
